import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { Order } from '../types';

export const useOrderNotifications = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminPage = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!isAdminPage) return;

    const requestNotificationPermission = async () => {
      if ('Notification' in window && Notification.permission === 'default') {
        await Notification.requestPermission();
      }
    };

    const showNewOrderNotification = (order: Order) => {
      if ('Notification' in window && Notification.permission === 'granted') {
        const notification = new Notification('New Order Received!', {
          body: `Order #${order.id} - ${order.total_items} items`,
          icon: 'https://edu.almuwasholah.com/wp-content/uploads/2026/02/logo-habib-1.png',
          tag: 'new-order',
          requireInteraction: true
        });
        
        notification.onclick = () => {
          window.focus();
          navigate('/admin/orders');
          notification.close();
        };
        
        setTimeout(() => notification.close(), 5000);
      }
    };

    requestNotificationPermission();

    const subscription = supabase
      .channel('global_order_notifications')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'habib_orders' }, (payload) => {
        console.log('New order notification:', payload);
        showNewOrderNotification(payload.new as Order);
      })
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [isAdminPage, navigate]);
};
